<template>
  <div>
    <section class="p-6">
      <div class="flex justify-between mb-2">
        <h1>Cat Clothes</h1>
        <button
          @click="openCreateModal"
          class="bg-pink-300 text-white font-bold py-2 px-4 rounded"
        >
          +
        </button>
      </div>

      <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 py-10">
        <div
          v-for="cat in cats"
          :key="cat.id"
          class="bg-white shadow-lg thumbnail"
        >
          <div class="relative">
            <div
              class="overlay absolute z-10 w-full h-full flex items-center justify-center"
            >
              <button @click="removeCat(cat.id)" class="btn">trash</button>
              <button
                @click="editModal(cat)"
                class="bg-purple-400 text-white font-bold py-2 px-4 rounded"
              >
                Edit
              </button>
            </div>
            <img
              class="w-full"
              :src="cat.image"
              :alt="'Image of a' + cat.name"
            />
          </div>
          <div class="p-2">
            <h2 class="font-bold">{{ cat.name }}</h2>
            <p>${{ cat.price }}</p>
          </div>
        </div>
      </div>

      <edit-cat-modal @exit="closeModal" v-if="modal" v-model="form" />
    </section>
  </div>
</template>

<script>
import { db } from "@/db";
import EditCatModal from "@/components/EditCatModal.vue";

export default {
  data: function () {
    return {
      form: {},
      modal: false,
      cats: [],
    };
  },
  components: {
    EditCatModal,
  },

  methods: {
    // create
    openCreateModal() {
      this.form = {
        name: null,
        price: 2.99,
        description: null,
        image: null,
        feature: false,
      };
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    editModal(product) {
      this.form = product;
      this.modal = true;
    },
    removeCat(id) {
      db.collection("cat").doc(id).delete();
    },
  },
  firestore: {
    cats: db.collection("cat"),
  },
};
</script>
<style scoped>
.thumbnail .overlay {
  opacity: 0;
}

.thumbnail:hover .overlay {
  opacity: 1;
}
</style>